import {VisitaVo} from './visita-vo';
import {PontoVo} from './ponto-vo';
import {EventoVo} from './evento-vo';
import {ClienteVo} from './cliente-vo';
import {Coord} from '~model/ngrx/polygon-ngrx';
import { PendenciaRota } from './pendencia-rota';
import { CardItemVo } from './card-item-vo';

export interface DadosRotaVo {
  momento: string;
  distancia: number;
  tempoNumero: number;
  valor: number;
  tempo: string;
  visitas: number;
  custoRota: number;
  custoTotalPlanejado: number;
}

export interface RotaVo {
  id: string;
  nome: string;
  identificador: string;
  placa: string;
  codigoVeiculo?: string;
  codigoCarroceria?: string;
  placaCarroceria?: string;
  cor: string;
  rotaCor: string;
  taxaDeSatisfacao: number;
  taxaDeRentabilidade: number;
  taxaDeOcupacao: number;
  distancia: number;
  numeroVisita: number;
  numeroOrdem: number;
  peso: number;
  valor?: number;
  tempo: string;
  limitePeso: number;
  volume: number;
  cubagem: number;
  horaInicio: string;
  horaFim: string;
  inicioHora?: string;
  inicioDia?: string;
  fimHora?: string;
  fimDia?: string;
  horaInicioNumber: number;
  horaFimNumber: number;
  horariosVisitas?: string[];
  saidaCD?: string;
  chegadaCD?: string;
  clientes: ClienteVo[];
  icones?: IconeVo[];
  eventos?: EventoVo[];
  arquivos?: ArquivoVo[];
  possuiCD?: boolean;
  iniciaCD?: boolean;
  finalizaCD?: boolean;
  idRotaInicial?: string;
  utilizaPernoite?: boolean;
  proxRotas?: string[];
  proximaVisita: string;
  pontosProximaVisita?: Coord[];
  proximaPosicao?: number;
  pontoAtual?: PontoVo;
  trajetoRealizado?: Coord[];
  trajetoRealizadoTerceiros?: GpsMapping;
  removida?: boolean;
  ativo?: boolean;
  finalizada?: boolean;
  visitasPendentes?: string[];
  oculto?: boolean;
  visitaDias: { [k: string]: VisitaVo[] };
  adiadas?: VisitaVo[];
  visitasIds: string[];
  cds: VisitaVo[];
  version: number;
  diffFim?: number;
  pontoAtualNumber?: number;
  temEscolta?: boolean;
  permiteCargaExpressa: boolean;
  tipoVeiculo: string;
  pendencia?: PendenciaRota;
  viavel?: boolean;
  motivo: string;
  motorista: string;
  indicadores?: CardItemVo[];
  excedeTempoParadaObrigatorio?: boolean;
  instanteFimRota?: string;
  instanteInicioRota?: string;
  tipoRastreamento: TipoGPSEnum;
  executado?: DadosRotaVo;
  planejado?: DadosRotaVo;
  custoKm?: number;
  custoTotalExecutado?: number;
  custoTotalPlanejado?: number;
  codigoOperacao?: string;
  tempoEstimado?: string;
  raioAtendimento?: number;
  smsAtrasoMinimo?: number;
  smsPedidoACaminho?: boolean;
  smsPedidoChegando?: boolean;
  smsPedidoEmAtraso?: boolean;
  smsPedidoEmRota?: boolean;
  smsPedidoRemovido?: boolean;
  utilizaRastreamentoTerceiros?: boolean;
  ativaTratativasIncidentes?: boolean;
}

export const emptyRota = (rota?: RotaVo): RotaVo => ({
  id: '',
  nome: '',
  identificador: '',
  clientes: [],
  cubagem: 0,
  distancia: 0,
  horaFim: '',
  horaFimNumber: 0,
  horaInicio: '',
  horaInicioNumber: 0,
  numeroOrdem: 0,
  numeroVisita: 0,
  peso: 0,
  limitePeso: 0,
  placa: '',
  codigoVeiculo: '',
  codigoCarroceria: '',
  placaCarroceria: '',
  proximaVisita: '',
  cor: '',
  rotaCor: '',
  taxaDeOcupacao: 0,
  taxaDeRentabilidade: 0,
  taxaDeSatisfacao: 0,
  tempo: '',
  motorista: '',
  valor: 0,
  volume: 0,
  visitaDias: {},
  visitasIds: [],
  cds: [],
  version: 0,
  temEscolta: false,
  permiteCargaExpressa: false,
  tipoVeiculo: 'PROPRIO',
  motivo: '',
  tipoRastreamento: TipoGPSEnum.PATHFIND,
  ...rota,
});

export interface IconeVo {
  iconID?: number;
  textID?: number;
  text?: string;
  time?: number;
  hour?: string;
  ordem?: number;
  grupo?: string;
  evento?: string;
  matIcon?: string;
  imageIcon?: string;
  toolTip?: string;
  diff?: number;
}

export interface ArquivoVo {
  coordenada: {
    latitude: number,
    longitude: number
  };
  listaArquivos: string[];
  tipo: string;
}

export enum TipoGPSEnum {
  VANGUARDA = "VANGUARDA",
  PATHFIND = "PATHFIND",
}

export type GpsMapping = {
  [key in TipoGPSEnum]: Coord[];
};

export interface MotoristaVo {
  nome: string;
  codigo: string;
  data: string;
}